import React from "react";
import StockType from "@irati/stock/enums/StockType";
import Code from "./Code";
var BirthdayBoxTicket = function (_a) {
    var vouchers = _a.vouchers;
    var codeVoucher = vouchers.find(function (voucher) { return voucher.type === StockType.TEXT; });
    var urlVoucher = vouchers.find(function (voucher) { return voucher.type === StockType.URL; });
    return (React.createElement("div", { className: "ticket_productTickets" },
        React.createElement("div", { className: "ticket_ticketWrapper tickets_borderBottom" },
            React.createElement("div", { className: "ticket_ticketWrapperInner" },
                React.createElement(Code, { voucher: codeVoucher, url: urlVoucher === null || urlVoucher === void 0 ? void 0 : urlVoucher.code })))));
};
export default BirthdayBoxTicket;
